import { HOOKS_TAP_MAX_DELAY, HOOKS_TAP_TOLERANCE } from '../constants';
import { useRef } from 'react';
import { eventX, eventY } from '../helpers/events';
import { useNodeRef } from './useNodeRef';
import { useVariable } from './useVariable';
import { useFunction } from './useFunction';
export const useTap = (onTap, initialRef,
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
useTouch = true, disabled = false, noEventsPropagation = false, noEventsDefault = false, tolerance = HOOKS_TAP_TOLERANCE, maxDelay = HOOKS_TAP_MAX_DELAY) => {
  const handleTap = useVariable(onTap);
  const startX = useRef(null);
  const startY = useRef(null);
  const lastX = useRef(null);
  const lastY = useRef(null);
  const moved = useRef(false);
  const cancelled = useRef(false);
  const startTime = useRef(null);
  const start = useFunction(e => {
    if (disabled) {
      return;
    }
    if (noEventsDefault) {
      e.preventDefault();
    }
    if (noEventsPropagation) {
      e.stopPropagation();
    }
    startTime.current = Date.now();
    startX.current = eventX(e);
    startY.current = eventY(e);
    lastX.current = eventX(e);
    lastY.current = eventY(e);
    moved.current = false;
    cancelled.current = false;
  });
  const cancel = useFunction(() => {
    cancelled.current = true;
    startTime.current = null;
  });
  const end = useFunction(e => {
    if (disabled) {
      return;
    }
    if (noEventsPropagation) {
      e.stopPropagation();
    }
    const lastStartTime = startTime.current;
    startTime.current = null;
    if (moved.current || cancelled.current || Date.now() - lastStartTime > maxDelay) {
      return;
    }
    const currentX = eventX(e, e.changedTouches);
    const currentY = eventY(e, e.changedTouches);
    handleTap.current?.(e, {
      x: currentX !== null ? currentX : lastX.current !== null ? lastX.current : startX.current,
      y: currentY !== null ? currentY : lastY.current !== null ? lastY.current : startY.current
    });
  });
  const move = useFunction(e => {
    if (disabled) {
      return;
    }
    if (noEventsPropagation) {
      e.stopPropagation();
    }
    if (!startTime.current) {
      return;
    }
    lastX.current = eventX(e);
    lastY.current = eventY(e);
    moved.current = moved.current || Math.abs(startX.current - lastX.current) > tolerance || Math.abs(startY.current - lastY.current) > tolerance;
  });
  const [setRef, nodeRef] = useNodeRef(initialRef, node => {
    node.addEventListener('touchstart', start, {
      passive: !noEventsPropagation && !noEventsDefault
    });
    node.addEventListener('touchend', end);
    node.addEventListener('touchcancel', cancel);
    node.addEventListener('touchmove', move, {
      passive: !noEventsPropagation && !noEventsDefault
    });
    node.addEventListener('mousedown', start);
    node.addEventListener('mouseup', end);
    node.addEventListener('mousemove', move);
  });
  return {
    nodeRef,
    setRef
  };
};